// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"ResetSendForm__loginForm__3ZNkC","alertsMb":"ResetSendForm__alertsMb__2N6Uf","submitButton":"ResetSendForm__submitButton__2RTzn","paragraph":"ResetSendForm__paragraph__1Yqrp","headline":"ResetSendForm__headline__3AGxm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResetSendForm/ResetSendForm.css
// module id = 1500
// module chunks = 0